import { MultiLangString } from './lingua_sistema';
import { FiltroPeridodoGravidanza } from './agenda_utente';
import { HmModelRest } from './abstract_model';
import { AreaVasta } from './anagrafica_geo';
import { Rimando } from './rimando';


export class MacrotemaFaq extends HmModelRest {
    static readonly rest_path = 'macrotemi';
    id: number;
    nome: MultiLangString;
    sottotitolo: MultiLangString;
}

export class CategoriaFaq extends HmModelRest {
    static readonly rest_path = 'categorie';
    id: number;
    nome: MultiLangString;
    //sottocategorie: SottoCategoriaFaq[];
}

export class SottoCategoriaFaq extends HmModelRest {
    static readonly rest_path = 'sottocategorie';
    id: number;
    nome: MultiLangString;
    categoria: number | CategoriaFaq;
}

export class Faq extends Rimando {
    static readonly rest_path = 'faq';
    id: number;
    macrotema: number; // | MacrotemaFaq;
    categoria: number; // | CategoriaFaq;
    sottocategoria: number; // | SottoCategoriaFaq;
    domanda: MultiLangString;
    risposta: MultiLangString;
    link: string;
    link_text: string;
    glossario: MultiLangString;
    immagine: boolean;
    area_vasta: number; // | AreaVasta;
    disabled: boolean;

    //parolechiave: string[]; // Parolachiave

    get risposta_it() {
        if (!this.risposta) return null;
        return this.risposta.it;
    }

    get risposta_en() {
        if (!this.risposta) return null;
        return this.risposta.en;
    }

    get risposta_fr() {
        if (!this.risposta) return null;
        return this.risposta.fr;
    }

    get risposta_es() {
        if (!this.risposta) return null;
        return this.risposta.es;
    }

    get risposta_sq() {
        if (!this.risposta) return null;
        return this.risposta.sq;
    }

    get risposta_ar() {
        if (!this.risposta) return null;
        return this.risposta.ar;
    }

    get risposta_zh() {
        if (!this.risposta) return null;
        return this.risposta.zh;
    }

    get risposta_ro() {
        if (!this.risposta) return null;
        return this.risposta.ro;
    }

    set risposta_it(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.it = v;
    }

    set risposta_en(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.en = v;
    }

    set risposta_fr(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.fr = v;
    }

    set risposta_es(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.es = v;
    }

    set risposta_sq(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.sq = v;
    }

    set risposta_ar(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.ar = v;
    }

    set risposta_zh(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.zh = v;
    }

    set risposta_ro(v: string) {
        if (!this.risposta) this.risposta = new MultiLangString();
        this.risposta.ro = v;
    }
}

export class InfoPagina extends HmModelRest {
    static readonly rest_path = 'info_pagina';
    id: number;
    pagina: string;
    label: MultiLangString;
    info: MultiLangString;
    youtube_code: string;

    get info_it() {
        if (!this.info) return null;
        return this.info.it;
    }

    get info_en() {
        if (!this.info) return null;
        return this.info.en;
    }

    get info_fr() {
        if (!this.info) return null;
        return this.info.fr;
    }

    get info_es() {
        if (!this.info) return null;
        return this.info.es;
    }

    get info_sq() {
        if (!this.info) return null;
        return this.info.sq;
    }

    get info_ar() {
        if (!this.info) return null;
        return this.info.ar;
    }

    get info_zh() {
        if (!this.info) return null;
        return this.info.zh;
    }

    get info_ro() {
        if (!this.info) return null;
        return this.info.ro;
    }

    set info_it(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.it = v;
    }

    set info_en(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.en = v;
    }

    set info_fr(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.fr = v;
    }

    set info_es(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.es = v;
    }

    set info_sq(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.sq = v;
    }

    set info_ar(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.ar = v;
    }

    set info_zh(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.zh = v;
    }

    set info_ro(v: string) {
        if (!this.info) this.info = new MultiLangString();
        this.info.ro = v;
    }

}

export class ParolaChiave extends HmModelRest {
    static readonly rest_path = 'info_pagina';
    id: number;
    informazione: number;
    parolachiave: any;
    pagina: string;
}

export class MessaggioHome extends FiltroPeridodoGravidanza {
    static readonly rest_path = 'messaggi_home';
    id: number;
    messaggio: MultiLangString;

    // get settimana_inizio(): number {
    //   return Math.floor(this.giorno_inizio / 7);
    // }

    // set settimana_inizio(sett) {
    //   this.giorno_inizio = sett * 7 + this.giorno_inizio % 7;
    // }

    // get giorno_settimana_inizio(): number {
    //   return this.giorno_inizio % 7;
    // }
    // set giorno_settimana_inizio(giorno_sett) {
    //   this.giorno_inizio = Math.floor(this.giorno_inizio / 7) * 7 + giorno_sett;
    // }

    // get settimana_fine(): number {
    //   return Math.floor(this.giorno_fine / 7);
    // }
    // set settimana_fine(sett) {
    //   this.giorno_fine = sett * 7 + this.giorno_fine % 7;
    // }

    // get giorno_settimana_fine(): number {
    //   return this.giorno_fine % 7;
    // }
    // set giorno_settimana_fine(giorno_sett) {
    //   this.giorno_fine = Math.floor(this.giorno_fine) / 7 * 7 + giorno_sett;
    // }
}
